import script from "./ArticleCommentContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArticleCommentContainer.vue?vue&type=script&setup=true&lang=ts"

import "./ArticleCommentContainer.vue?vue&type=style&index=0&id=f4806684&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3567651837/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f4806684"]])

export default __exports__